const NUMBER_FORMATTER = new Intl.NumberFormat("es-ES", {
  maximumFractionDigits: 8,
});

const INPUT_NUMBER_FORMATTER = new Intl.NumberFormat("en-US", {
  useGrouping: false,
  maximumFractionDigits: 8,
});

const CURRENCY_FORMATTER = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const INVENTORY_COUNT_UI_STYLES = `
  .ic-card {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(12, 18, 34, 0.96), rgba(7, 13, 25, 0.96)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(52, 211, 153, 0.08)) border-box;
    box-shadow: 0 24px 72px rgba(2, 8, 20, 0.3);
    overflow: hidden;
    color: rgba(237, 243, 255, 0.95);
  }

  .ic-cardHead {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 20px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .ic-cardTitle {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 800;
    color: rgba(241, 246, 255, 0.96);
  }

  .ic-cardSubtitle {
    margin: 6px 0 0;
    color: rgba(190, 205, 227, 0.66);
    font-size: 0.84rem;
    line-height: 1.45;
  }

  .ic-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
  }

  .ic-toolbarMain {
    display: flex;
    flex: 1 1 auto;
    gap: 12px;
    align-items: center;
    min-width: 0;
  }

  .ic-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
  }

  .ic-search {
    width: min(420px, 100%);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(240, 245, 255, 0.92);
    padding: 10px 12px;
    outline: none;
  }

  .ic-search::placeholder {
    color: rgba(240, 245, 255, 0.46);
  }

  .ic-search:focus,
  .ic-input:focus,
  .ic-select:focus,
  .ic-textarea:focus {
    border-color: rgba(48, 216, 255, 0.6);
    box-shadow: 0 0 0 3px rgba(48, 216, 255, 0.15);
  }

  .ic-chipRow {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ic-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 38px;
    padding: 8px 12px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(226, 234, 247, 0.84);
    font-size: 0.77rem;
    font-weight: 800;
    cursor: pointer;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  }

  .ic-chip:hover {
    transform: translateY(-1px);
  }

  .ic-chip span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 7px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(240, 245, 255, 0.88);
    font-size: 0.73rem;
    font-weight: 900;
    line-height: 1;
  }

  .ic-chip--active {
    border-color: rgba(34, 211, 238, 0.58);
    background: rgba(34, 211, 238, 0.16);
    color: rgba(214, 251, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(34, 211, 238, 0.09);
  }

  .ic-chip--active span {
    background: rgba(34, 211, 238, 0.24);
    color: rgba(214, 251, 255, 0.98);
  }

  .ic-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
    padding: 14px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
  }

  .ic-stat {
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.025);
    min-width: 0;
  }

  .ic-statLabel {
    color: rgba(218, 229, 247, 0.63);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.55px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .ic-statValue {
    color: rgba(238, 244, 255, 0.95);
    font-size: 1.04rem;
    font-weight: 800;
    line-height: 1.1;
  }

  .ic-tableWrap {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(109, 208, 235, 0.72) rgba(255, 255, 255, 0.08);
  }

  .ic-tableWrap--modal {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.02);
  }

  .ic-tableWrap--sessionModal {
    flex: 0 0 auto;
    min-height: 0;
    position: relative;
    isolation: isolate;
    overflow: visible;
    z-index: 1;
  }

  .ic-table {
    width: 100%;
    min-width: 1180px;
    border-collapse: separate;
    border-spacing: 0;
  }

  .ic-table--session {
    min-width: 0;
    table-layout: fixed;
  }

  .ic-table--session th:last-child,
  .ic-table--session td:last-child {
    text-align: right;
  }

  .ic-table--sessionLegacy th:nth-child(1),
  .ic-table--sessionLegacy td:nth-child(1) {
    width: 28%;
  }

  .ic-table--sessionLegacy th:nth-child(2),
  .ic-table--sessionLegacy td:nth-child(2) {
    width: 9%;
  }

  .ic-table--sessionLegacy th:nth-child(3),
  .ic-table--sessionLegacy td:nth-child(3) {
    width: 25%;
  }

  .ic-table--sessionLegacy th:nth-child(4),
  .ic-table--sessionLegacy td:nth-child(4) {
    width: 12%;
  }

  .ic-table--sessionLegacy th:nth-child(5),
  .ic-table--sessionLegacy td:nth-child(5) {
    width: 8%;
  }

  .ic-table--sessionLegacy th:nth-child(6),
  .ic-table--sessionLegacy td:nth-child(6) {
    width: 9%;
  }

  .ic-table--sessionLegacy th:nth-child(7),
  .ic-table--sessionLegacy td:nth-child(7) {
    width: 9%;
  }

  .ic-table--sessionLocation {
    min-width: 0;
    width: 100%;
  }

  .ic-table--sessionLocation th,
  .ic-table--sessionLocation td {
    overflow: hidden;
  }

  .ic-table--sessionLocation thead th {
    white-space: normal;
    line-height: 1.14;
  }

  .ic-table--pastItems {
    min-width: 860px;
  }

  .ic-table thead th {
    position: sticky;
    top: 0;
    z-index: 5;
    text-align: left;
    padding: 12px;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.45px;
    font-weight: 800;
    color: rgba(214, 227, 247, 0.8);
    background: linear-gradient(180deg, rgba(25, 31, 53, 0.95), rgba(14, 18, 34, 0.95));
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    white-space: nowrap;
  }

  .ic-tableWrap--sessionModal .ic-table thead {
    position: sticky;
    top: 0;
    z-index: 80;
  }

  .ic-tableWrap--sessionModal .ic-table thead tr {
    position: relative;
    z-index: 80;
  }

  .ic-tableWrap--sessionModal .ic-table thead th {
    top: 0;
    z-index: 90;
    background: #10162a;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.08),
      0 12px 24px rgba(2, 8, 20, 0.42);
  }

  .ic-tableWrap--sessionModal .ic-table tbody tr {
    position: relative;
    z-index: 0;
  }

  .ic-tableWrap--sessionModal .ic-table tbody tr:hover {
    z-index: 1;
  }

  .ic-locationWindowCell {
    width: var(--ic-location-window-width);
    min-width: var(--ic-location-window-width);
    padding: 0 !important;
    overflow: hidden;
  }

  .ic-locationScroll {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
  }

  .ic-locationScroll::-webkit-scrollbar {
    display: none;
  }

  .ic-locationStrip {
    display: grid;
    grid-template-columns: repeat(var(--ic-location-count, 1), minmax(var(--ic-location-column-width, 140px), 1fr));
    width: max(100%, var(--ic-location-strip-min-width, var(--ic-location-column-width, 140px)));
  }

  .ic-locationHeadCell {
    min-width: 0;
    padding: 12px 14px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
  }

  .ic-locationHeadCell:last-child,
  .ic-locationCountCell--strip:last-child {
    border-right: 0;
  }

  .ic-table tbody tr {
    background: rgba(255, 255, 255, 0.018);
    transition: background 120ms ease, box-shadow 120ms ease, transform 120ms ease;
  }

  .ic-table tbody tr:nth-child(even) {
    background: rgba(255, 255, 255, 0.012);
  }

  .ic-table tbody tr:hover {
    background: rgba(48, 216, 255, 0.055);
    transform: translateY(-1px);
    box-shadow: 0 16px 44px rgba(0, 0, 0, 0.22);
  }

  .ic-table tbody td,
  .ic-table tfoot td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    color: rgba(234, 241, 252, 0.87);
    font-size: 0.84rem;
    vertical-align: middle;
    white-space: nowrap;
  }

  .ic-table tfoot td {
    background: rgba(255, 255, 255, 0.03);
    font-weight: 800;
  }

  .ic-number {
    text-align: right;
    font-variant-numeric: tabular-nums;
  }

  .ic-muted {
    color: rgba(210, 222, 242, 0.74);
  }

  .ic-itemCell {
    position: relative;
  }

  .ic-itemCell--editable {
    padding-right: 28px !important;
  }

  .ic-lineRemoveBtn {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 17px;
    height: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(248, 113, 113, 0.38);
    border-radius: 999px;
    padding: 0;
    background: rgba(239, 68, 68, 0.2);
    color: rgba(254, 202, 202, 0.9);
    cursor: pointer;
    font-size: 0.62rem;
    font-weight: 900;
    line-height: 1;
    opacity: 0.42;
    transition: opacity 120ms ease, border-color 120ms ease, background 120ms ease;
  }

  .ic-itemCell:hover .ic-lineRemoveBtn,
  .ic-lineRemoveBtn:focus-visible {
    opacity: 0.95;
    border-color: rgba(248, 113, 113, 0.7);
    background: rgba(239, 68, 68, 0.36);
  }

  .ic-rowActionCell {
    text-align: center;
  }

  .ic-lineCorrectBtn {
    min-height: 26px;
    border: 1px solid rgba(245, 158, 11, 0.34);
    border-radius: 999px;
    padding: 4px 9px;
    background: rgba(245, 158, 11, 0.08);
    color: rgba(254, 240, 138, 0.95);
    font-size: 0.68rem;
    font-weight: 900;
    line-height: 1;
    cursor: pointer;
    transition: border-color 120ms ease, background 120ms ease, color 120ms ease;
  }

  .ic-lineCorrectBtn:hover,
  .ic-lineCorrectBtn:focus-visible {
    border-color: rgba(245, 158, 11, 0.72);
    background: rgba(245, 158, 11, 0.18);
    color: rgba(255, 247, 215, 0.98);
  }

  .ic-lineCorrectBtn--mobile {
    flex: 0 0 auto;
    min-height: 26px;
    white-space: nowrap;
  }

  .ic-restoreBadge {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    border-radius: 999px;
    border: 1px solid rgba(248, 113, 113, 0.24);
    padding: 2px 7px;
    background: rgba(239, 68, 68, 0.1);
    color: rgba(254, 202, 202, 0.82);
    font-size: 0.62rem;
    font-weight: 900;
    text-transform: uppercase;
    vertical-align: middle;
  }

  .ic-strong {
    color: rgba(244, 248, 255, 0.96);
    font-weight: 800;
  }

  .ic-ellipsis {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }

  .ic-countLocations {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
    min-width: 170px;
    max-width: 290px;
    white-space: normal;
  }

  .ic-countLocation {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    max-width: 170px;
    padding: 4px 8px;
    border: 1px solid rgba(34, 211, 238, 0.2);
    border-radius: 999px;
    background: rgba(34, 211, 238, 0.08);
    color: rgba(188, 248, 255, 0.9);
    font-size: 0.7rem;
    font-weight: 750;
    line-height: 1.15;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-countLocation--more {
    flex: 0 0 auto;
    border-color: rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(218, 229, 247, 0.72);
  }

  .ic-productGroupText {
    display: -webkit-box;
    max-width: 100%;
    overflow: hidden;
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.32;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ic-table--sessionLocation .ic-productGroupText {
    -webkit-line-clamp: 3;
  }

  .ic-status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 94px;
    padding: 5px 10px;
    border-radius: 999px;
    border: 1px solid transparent;
    font-size: 0.73rem;
    font-weight: 800;
    text-transform: uppercase;
  }

  .ic-status--open {
    background: rgba(34, 211, 238, 0.15);
    color: rgba(188, 248, 255, 0.96);
    border-color: rgba(34, 211, 238, 0.42);
  }

  .ic-status--progress {
    background: rgba(245, 158, 11, 0.16);
    color: rgba(254, 240, 138, 0.98);
    border-color: rgba(245, 158, 11, 0.38);
  }

  .ic-status--finalized {
    background: rgba(34, 197, 94, 0.14);
    color: rgba(220, 252, 231, 0.98);
    border-color: rgba(34, 197, 94, 0.38);
  }

  .ic-status--reverted {
    background: rgba(168, 85, 247, 0.15);
    color: rgba(233, 213, 255, 0.98);
    border-color: rgba(168, 85, 247, 0.36);
  }

  .ic-status--cancelled {
    background: rgba(239, 68, 68, 0.14);
    color: rgba(254, 202, 202, 0.96);
    border-color: rgba(239, 68, 68, 0.36);
  }

  .ic-status--draft {
    background: rgba(148, 163, 184, 0.14);
    color: rgba(226, 232, 240, 0.96);
    border-color: rgba(148, 163, 184, 0.35);
  }

  .ic-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(231, 239, 252, 0.9);
    font-size: 0.8rem;
    font-weight: 800;
    white-space: nowrap;
  }

  .ic-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 38px;
    padding: 9px 14px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(232, 240, 252, 0.92);
    font-size: 0.8rem;
    font-weight: 800;
    line-height: 1.1;
    cursor: pointer;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  }

  .ic-btn:hover {
    transform: translateY(-1px);
  }

  .ic-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }

  .ic-btn--primary {
    border-color: rgba(34, 211, 238, 0.55);
    background: linear-gradient(135deg, rgba(34, 211, 238, 0.95), rgba(59, 130, 246, 0.88));
    color: #07131e;
  }

  .ic-btn--success {
    border-color: rgba(34, 197, 94, 0.5);
    background: linear-gradient(135deg, rgba(74, 222, 128, 0.9), rgba(16, 185, 129, 0.88));
    color: #07160f;
  }

  .ic-btn--warning {
    border-color: rgba(245, 158, 11, 0.48);
    background: linear-gradient(135deg, rgba(251, 191, 36, 0.94), rgba(249, 115, 22, 0.88));
    color: #171005;
  }

  .ic-btn--danger {
    border-color: rgba(239, 68, 68, 0.46);
    background: rgba(239, 68, 68, 0.1);
    color: rgba(254, 202, 202, 0.96);
  }

  .ic-btn--ghost {
    background: transparent;
  }

  .ic-linkButton,
  .ic-codeButton,
  .ic-unitTrigger {
    border: 0;
    padding: 0;
    background: transparent;
    color: rgba(126, 229, 255, 0.94);
    font-size: 0.8rem;
    font-weight: 800;
    cursor: pointer;
    text-align: left;
  }

  .ic-codeButton {
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .ic-linkButton:hover,
  .ic-codeButton:hover,
  .ic-unitTrigger:hover {
    color: rgba(179, 242, 255, 0.98);
    text-decoration: underline;
  }

  .ic-diff--positive {
    color: rgba(134, 239, 172, 0.96);
    font-weight: 800;
  }

  .ic-diff--negative {
    color: rgba(252, 165, 165, 0.96);
    font-weight: 800;
  }

  .ic-empty {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: rgba(204, 217, 241, 0.65);
    padding: 24px 14px;
    font-size: 0.95rem;
  }

  .ic-mobileList {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
    min-height: 0;
    overflow: auto;
  }

  .ic-mobileCard {
    border-radius: 18px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.03);
    padding: 14px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.26);
  }

  .ic-mobileTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 8px;
  }

  .ic-mobileCode {
    color: rgba(126, 229, 255, 0.94);
    font-size: 0.82rem;
    font-weight: 900;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .ic-mobileTitle {
    margin-top: 4px;
    font-size: 0.94rem;
    font-weight: 800;
    color: rgba(244, 248, 255, 0.96);
    overflow-wrap: anywhere;
  }

  .ic-mobileRows {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 10px;
    margin-top: 10px;
  }

  .ic-mobileFieldLabel {
    font-size: 0.67rem;
    color: rgba(206, 219, 243, 0.58);
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 2px;
    font-weight: 700;
  }

  .ic-mobileFieldValue {
    font-size: 0.82rem;
    color: rgba(232, 239, 251, 0.9);
    overflow-wrap: anywhere;
  }

  .ic-mobileFieldValue .ic-countLocations {
    min-width: 0;
    max-width: none;
  }

  .ic-mobileActions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }

  .ic-modalOverlay,
  .ic-dialogOverlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    background: rgba(2, 8, 20, 0.82);
    backdrop-filter: blur(8px);
  }

  .ic-modalOverlay {
    z-index: 9990;
  }

  .ic-modalOverlay--inventorySession {
    padding: 4px;
  }

  .ic-dialogOverlay {
    z-index: 10020;
  }

  .ic-modal {
    width: min(1100px, 96vw);
    max-height: calc(100dvh - 36px);
    display: flex;
    flex-direction: column;
    border-radius: 28px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(12, 18, 34, 0.98), rgba(7, 13, 25, 0.98)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(52, 211, 153, 0.08)) border-box;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
    overflow: hidden;
    color: rgba(237, 243, 255, 0.95);
  }

  .ic-modal--wide {
    width: calc(100vw - 16px);
    max-width: none;
  }

  .ic-modal--inventorySession {
    width: calc(100vw - 8px);
    max-width: calc(100vw - 8px);
    max-height: calc(100dvh - 8px);
  }

  .ic-modal--lineCorrection {
    width: min(560px, 94vw);
  }

  .ic-modal--inventorySession .ic-modalBody {
    padding: 12px;
    overflow-x: hidden;
  }

  .ic-dialog {
    width: min(460px, 94vw);
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background:
      linear-gradient(180deg, rgba(12, 18, 34, 0.98), rgba(7, 13, 25, 0.98)) padding-box,
      linear-gradient(135deg, rgba(34, 211, 238, 0.18), rgba(59, 130, 246, 0.08), rgba(52, 211, 153, 0.08)) border-box;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
    padding: 20px;
    color: rgba(237, 243, 255, 0.95);
  }

  .ic-dialogTitle {
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
    color: rgba(244, 248, 255, 0.98);
  }

  .ic-dialogText {
    margin: 0;
    color: rgba(205, 219, 242, 0.72);
    font-size: 0.88rem;
    line-height: 1.5;
  }

  .ic-dialogCheckbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    border: 1px solid rgba(245, 158, 11, 0.26);
    border-radius: 14px;
    padding: 10px 12px;
    background: rgba(245, 158, 11, 0.07);
    color: rgba(254, 240, 138, 0.92);
    cursor: pointer;
  }

  .ic-dialogCheckbox input {
    flex: 0 0 auto;
    margin-top: 2px;
    accent-color: #f59e0b;
  }

  .ic-dialogCheckbox span {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 3px;
  }

  .ic-dialogCheckbox strong {
    color: rgba(255, 247, 215, 0.98);
    font-size: 0.82rem;
    font-weight: 900;
  }

  .ic-dialogCheckbox small {
    color: rgba(218, 229, 247, 0.68);
    font-size: 0.72rem;
    line-height: 1.25;
  }

  .ic-dialogActions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
  }

  .ic-correctionSummary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .ic-correctionSummary > div {
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 12px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.035);
  }

  .ic-correctionSummary span,
  .ic-correctionLocationRow small {
    display: block;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.68rem;
    font-weight: 900;
    text-transform: uppercase;
  }

  .ic-correctionSummary strong {
    display: block;
    margin-top: 4px;
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.94rem;
  }

  .ic-correctionLocationList {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .ic-correctionUnitPicker {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }

  .ic-correctionUnitOptions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ic-correctionUnitOption {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-height: 30px;
    border: 1px solid rgba(255, 255, 255, 0.11);
    border-radius: 999px;
    padding: 5px 10px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(232, 240, 252, 0.86);
    cursor: pointer;
  }

  .ic-correctionUnitOption strong {
    font-size: 0.74rem;
    font-weight: 900;
  }

  .ic-correctionUnitOption small {
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.66rem;
    font-weight: 900;
  }

  .ic-correctionUnitOption.is-active {
    border-color: rgba(34, 211, 238, 0.52);
    background: rgba(34, 211, 238, 0.12);
    color: rgba(203, 250, 255, 0.98);
  }

  .ic-correctionUnitOption:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .ic-correctionLocationRow {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 132px;
    gap: 12px;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 12px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.035);
  }

  .ic-correctionLocationRow strong {
    display: block;
    min-width: 0;
    color: rgba(244, 248, 255, 0.96);
    font-size: 0.82rem;
    overflow-wrap: anywhere;
  }

  .ic-correctionReason {
    min-height: 88px;
    resize: vertical;
    line-height: 1.35;
  }

  .ic-modalBody {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    min-height: 0;
    overflow: auto;
  }

  .ic-modalHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }

  .ic-modalHeaderMain {
    flex: 1 1 auto;
    min-width: 0;
  }

  .ic-modalHeaderActions {
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    min-width: 0;
    flex-wrap: wrap;
  }

  .ic-modal--inventorySession .ic-modalHeader {
    align-items: center;
    gap: 12px;
  }

  .ic-modal--inventorySession .ic-modalSubtitle {
    margin-top: 5px;
  }

  .ic-sessionActions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .ic-modalKicker {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    color: rgba(135, 230, 255, 0.84);
    font-size: 0.74rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.18em;
  }

  .ic-modalTitle {
    margin: 0;
    font-size: clamp(1.2rem, 2vw, 1.7rem);
    font-weight: 900;
    letter-spacing: -0.03em;
    color: rgba(244, 248, 255, 0.98);
  }

  .ic-modalSubtitle {
    margin: 8px 0 0;
    color: rgba(205, 219, 242, 0.7);
    font-size: 0.88rem;
    line-height: 1.5;
  }

  .ic-modalBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(231, 239, 252, 0.9);
    font-size: 0.8rem;
    font-weight: 800;
    white-space: nowrap;
  }

  .ic-modal--selectionEditor {
    width: min(980px, calc(100vw - 48px));
  }

  .ic-summaryBar {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 10px;
  }

  .ic-modal--inventorySession .ic-summaryBar {
    grid-template-columns: repeat(5, minmax(130px, 1fr));
  }

  .ic-summaryItem {
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.025);
  }

  .ic-summaryItemLabel {
    color: rgba(218, 229, 247, 0.63);
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.55px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  .ic-summaryItemValue {
    color: rgba(238, 244, 255, 0.95);
    font-size: 0.94rem;
    font-weight: 800;
  }

  .ic-formGrid,
  .ic-filterGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 12px;
  }

  .ic-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .ic-label {
    color: rgba(218, 229, 247, 0.7);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.55px;
    font-weight: 700;
  }

  .ic-input,
  .ic-select,
  .ic-textarea {
    box-sizing: border-box;
    width: 100%;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(240, 245, 255, 0.92);
    padding: 10px 12px;
    outline: none;
    box-shadow: none;
    line-height: 1.35;
  }

  .ic-input[readonly],
  .ic-input:disabled,
  .ic-select:disabled,
  .ic-textarea:disabled {
    color: rgba(206, 219, 243, 0.7);
    background: rgba(255, 255, 255, 0.035);
  }

  .ic-inlineInput[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  .ic-inlineInput[type="number"]::-webkit-outer-spin-button,
  .ic-inlineInput[type="number"]::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }

  .ic-select option {
    color: #08101d;
    background: #ffffff;
  }

  .ic-textarea {
    min-height: 88px;
    resize: vertical;
  }

  .ic-textarea--compact {
    min-height: 54px;
    resize: none;
  }

  .ic-input--notesLine {
    height: 44px;
    min-height: 44px;
    padding: 10px 12px;
    line-height: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ic-sessionUtilityRow {
    position: relative;
    z-index: 3;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(220px, 360px);
    gap: 12px;
    align-items: end;
    margin-bottom: 6px;
  }

  .ic-notesField {
    position: relative;
    z-index: 1;
  }

  .ic-countSearchField {
    position: relative;
    z-index: 1;
  }

  .ic-mobileCountContext,
  .ic-mobileLocationPanel,
  .ic-mobileCountList {
    display: none;
  }

  .ic-mobileLineRemoveBtn,
  .ic-mobileLocationTab,
  .ic-mobileQuickAction,
  .ic-countSearchClear {
    font: inherit;
  }

  .ic-countSearchControl {
    position: relative;
  }

  .ic-countSearchClear {
    display: none;
  }

  .ic-notesLineText {
    box-sizing: border-box;
    width: 100%;
    min-height: 42px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.035);
    color: rgba(206, 219, 243, 0.8);
    padding: 10px 12px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ic-checkboxRow {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 46px;
    color: rgba(205, 219, 242, 0.78);
    font-size: 0.84rem;
  }

  .ic-checkboxRow input {
    accent-color: #22d3ee;
  }

  .ic-filterCard,
  .ic-infoCard {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 18px;
    padding: 14px;
    background: rgba(255, 255, 255, 0.025);
  }

  .ic-filterCardTitle,
  .ic-infoLabel {
    color: rgba(218, 229, 247, 0.7);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.55px;
    font-weight: 700;
  }

  .ic-infoValue {
    color: rgba(238, 244, 255, 0.95);
    font-size: 0.92rem;
    font-weight: 800;
  }

  .ic-filterTagList,
  .ic-sessionFilters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .ic-filterTagList--scope {
    gap: 9px 10px;
    align-content: flex-start;
  }

  .ic-selectionGrid {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) minmax(260px, 0.8fr);
    gap: 12px;
    align-items: stretch;
  }

  .ic-selectionCard {
    display: flex;
    min-width: 0;
    min-height: 96px;
    flex-direction: column;
    gap: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.026);
  }

  .ic-selectionCardHead {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }

  .ic-selectionActions {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .ic-selectionTitle {
    color: rgba(238, 244, 255, 0.96);
    font-size: 0.82rem;
    font-weight: 900;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .ic-selectionMeta,
  .ic-selectionEmpty,
  .ic-selectionEditorNote {
    color: rgba(205, 219, 242, 0.64);
    font-size: 0.76rem;
    font-weight: 700;
    line-height: 1.35;
  }

  .ic-miniAddBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    border: 1px solid rgba(34, 197, 94, 0.42);
    border-radius: 999px;
    padding: 4px 12px;
    background: rgba(34, 197, 94, 0.14);
    color: rgba(187, 247, 208, 0.98);
    cursor: pointer;
    font-size: 0.72rem;
    font-weight: 900;
    line-height: 1;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease;
  }

  .ic-miniAddBtn:hover {
    transform: translateY(-1px);
    border-color: rgba(34, 197, 94, 0.68);
    background: rgba(34, 197, 94, 0.22);
  }

  .ic-miniAddBtn--secondary {
    border-color: rgba(109, 208, 235, 0.42);
    background: rgba(109, 208, 235, 0.12);
    color: rgba(214, 251, 255, 0.96);
  }

  .ic-miniAddBtn--secondary:hover {
    border-color: rgba(109, 208, 235, 0.68);
    background: rgba(109, 208, 235, 0.2);
  }

  .ic-filterTag {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 0;
    min-width: 0;
    padding: 7px 10px;
    border-radius: 999px;
    border: 1px solid rgba(34, 211, 238, 0.24);
    background: rgba(34, 211, 238, 0.12);
    color: rgba(214, 251, 255, 0.94);
    font-size: 0.76rem;
    font-weight: 800;
  }

  .ic-filterTag--scope {
    overflow: visible;
    padding: 0;
    border-color: rgba(148, 163, 184, 0.22);
    background: rgba(15, 23, 42, 0.35);
    color: rgba(238, 244, 255, 0.94);
  }

  .ic-filterTypePill {
    align-self: stretch;
    display: inline-flex;
    align-items: center;
    border-radius: 999px 0 0 999px;
    padding: 7px 8px 7px 10px;
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.62rem;
    font-weight: 900;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .ic-filterTagValue {
    min-width: 0;
    display: inline-flex;
    align-items: center;
    border-radius: 0 999px 999px 0;
    padding: 7px 12px 7px 9px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-filterTag--families {
    border-color: rgba(34, 211, 238, 0.34);
  }

  .ic-filterTag--families .ic-filterTypePill {
    background: rgba(8, 145, 178, 0.72);
  }

  .ic-filterTag--families .ic-filterTagValue {
    background: rgba(34, 211, 238, 0.12);
    color: rgba(214, 251, 255, 0.96);
  }

  .ic-filterTag--subfamilies {
    border-color: rgba(34, 197, 94, 0.34);
  }

  .ic-filterTag--subfamilies .ic-filterTypePill {
    background: rgba(22, 101, 52, 0.76);
  }

  .ic-filterTag--subfamilies .ic-filterTagValue {
    background: rgba(34, 197, 94, 0.12);
    color: rgba(220, 252, 231, 0.96);
  }

  .ic-filterTag--categories {
    border-color: rgba(245, 158, 11, 0.38);
  }

  .ic-filterTag--categories .ic-filterTypePill {
    background: rgba(180, 83, 9, 0.76);
  }

  .ic-filterTag--categories .ic-filterTagValue {
    background: rgba(245, 158, 11, 0.12);
    color: rgba(254, 243, 199, 0.96);
  }

  .ic-filterTag--subcategories {
    border-color: rgba(168, 85, 247, 0.38);
  }

  .ic-filterTag--subcategories .ic-filterTypePill {
    background: rgba(107, 33, 168, 0.76);
  }

  .ic-filterTag--subcategories .ic-filterTagValue {
    background: rgba(168, 85, 247, 0.12);
    color: rgba(243, 232, 255, 0.96);
  }

  .ic-filterTag--location {
    gap: 8px;
  }

  .ic-filterTag--removable {
    margin-top: 4px;
  }

  .ic-filterTag--removable:not(.ic-filterTag--scope) {
    padding-right: 16px;
  }

  .ic-filterTag--scope.ic-filterTag--removable .ic-filterTagValue {
    padding-right: 18px;
  }

  .ic-filterCard--locations {
    gap: 12px;
  }

  .ic-locationChoiceGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 10px;
  }

  .ic-locationChoice {
    min-width: 0;
    min-height: 62px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 16px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.035);
    color: rgba(228, 237, 250, 0.86);
    cursor: pointer;
    text-align: left;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease;
  }

  .ic-locationChoice:hover {
    transform: translateY(-1px);
    border-color: rgba(34, 211, 238, 0.32);
    background: rgba(34, 211, 238, 0.075);
  }

  .ic-locationChoice--active {
    border-color: rgba(34, 211, 238, 0.58);
    background: rgba(34, 211, 238, 0.14);
    color: rgba(214, 251, 255, 0.96);
  }

  .ic-locationChoiceName {
    max-width: 100%;
    overflow-wrap: anywhere;
    font-size: 0.84rem;
    font-weight: 900;
  }

  .ic-locationChoiceMeta {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .ic-filterRemove {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 999px;
    padding: 0;
    background: rgba(239, 68, 68, 0.95);
    color: #ffffff;
    cursor: pointer;
    font-size: 0.62rem;
    font-weight: 900;
    line-height: 1;
    box-shadow: 0 6px 18px rgba(127, 29, 29, 0.34);
  }

  .ic-filterRemove:hover {
    background: rgba(220, 38, 38, 1);
  }

  .ic-modalFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 2px;
  }

  .ic-modalFooterRight {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
  }

  .ic-choiceList {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ic-choiceButton {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 16px;
    padding: 12px 14px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(236, 243, 255, 0.94);
    cursor: pointer;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  }

  .ic-choiceButton:hover {
    transform: translateY(-1px);
    border-color: rgba(34, 211, 238, 0.3);
    background: rgba(34, 211, 238, 0.08);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.22);
  }

  .ic-choicePrimary {
    font-size: 0.9rem;
    font-weight: 800;
    color: rgba(244, 248, 255, 0.98);
  }

  .ic-choiceMeta {
    margin-top: 4px;
    color: rgba(205, 219, 242, 0.68);
    font-size: 0.8rem;
    line-height: 1.4;
  }

  .ic-inlineInput {
    width: 88px;
    margin-left: auto;
  }

  .ic-locationCountCell {
    position: relative;
    height: 76px;
    padding-bottom: 26px !important;
  }

  .ic-locationCountCell--strip {
    box-sizing: border-box;
    padding: 10px 12px 26px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.055);
    text-align: center;
  }

  .ic-locationCountCell .ic-inlineInput {
    width: 84px;
  }

  .ic-locationCountCell--strip .ic-inlineInput {
    display: block;
    margin: 0 auto;
  }

  .ic-countCorners {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 6px;
    display: flex;
    justify-content: space-between;
    gap: 8px;
    color: rgba(196, 211, 235, 0.58);
    font-size: 0.64rem;
    font-weight: 800;
    line-height: 1;
    pointer-events: none;
  }

  .ic-countCorners span {
    flex: 1 1 0;
    max-width: 48%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-countCorners span:first-child {
    text-align: left;
  }

  .ic-countCorners span:last-child {
    text-align: right;
  }

  .ic-scopeFinalCell,
  .ic-globalFinalCell {
    position: relative;
    height: 76px;
    padding-bottom: 26px !important;
  }

  .ic-finalCellValue {
    font-weight: 900;
  }

  .ic-finalCellValue--global {
    color: rgba(196, 211, 235, 0.66);
    font-style: italic;
    font-weight: 700;
  }

  .ic-globalFinalCorner {
    position: absolute;
    right: 10px;
    bottom: 6px;
    color: rgba(196, 211, 235, 0.58);
    font-size: 0.64rem;
    font-weight: 800;
    line-height: 1;
  }

  .ic-globalFinalCell {
    color: rgba(196, 211, 235, 0.66);
  }

  .ic-mobileCountContext {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 8px;
    background: rgba(255, 255, 255, 0.024);
  }

  .ic-mobileCountContextMeta {
    display: grid;
    grid-template-columns: minmax(92px, 0.42fr) minmax(0, 1fr);
    gap: 8px;
    align-items: end;
  }

  .ic-mobileSnapshotPill,
  .ic-mobileLocationCompact {
    min-width: 0;
  }

  .ic-mobileSnapshotPill {
    min-height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 6px 8px;
    background: rgba(255, 255, 255, 0.02);
  }

  .ic-mobileSnapshotPill span,
  .ic-mobileLocationCompact span {
    color: rgba(205, 219, 242, 0.56);
    font-size: 0.62rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1;
    text-transform: uppercase;
  }

  .ic-mobileSnapshotPill strong {
    margin-top: 4px;
    color: rgba(238, 244, 255, 0.9);
    font-size: 0.78rem;
    font-weight: 900;
    line-height: 1.05;
    white-space: nowrap;
  }

  .ic-mobileLocationCompact {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .ic-mobileQuickActions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 8px;
  }

  .ic-mobileQuickAction {
    min-height: 32px;
    border: 1px solid rgba(109, 208, 235, 0.24);
    border-radius: 10px;
    padding: 6px 8px;
    background: rgba(109, 208, 235, 0.07);
    color: rgba(214, 251, 255, 0.88);
    cursor: pointer;
    font-size: 0.72rem;
    font-weight: 900;
    line-height: 1;
  }

  .ic-mobileLocationPanel {
    border: 1px solid rgba(34, 211, 238, 0.18);
    border-radius: 14px;
    padding: 10px;
    background: rgba(34, 211, 238, 0.055);
  }

  .ic-mobileLocationTop {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
  }

  .ic-mobileLocationTitleGroup {
    min-width: 0;
  }

  .ic-mobileLocationTitle {
    margin-top: 3px;
    color: rgba(244, 248, 255, 0.98);
    font-size: 0.98rem;
    font-weight: 900;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-mobileLocationSelect {
    height: 36px;
    min-height: 36px;
    border-radius: 10px;
    padding: 7px 9px;
    font-size: 0.78rem;
    font-weight: 800;
  }

  .ic-mobileLocationTabs {
    display: flex;
    gap: 8px;
    margin-top: 10px;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
  }

  .ic-mobileLocationTabs::-webkit-scrollbar {
    display: none;
  }

  .ic-mobileLocationTab {
    flex: 0 0 auto;
    min-width: 118px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 999px;
    padding: 8px 11px;
    background: rgba(255, 255, 255, 0.045);
    color: rgba(222, 234, 250, 0.86);
    cursor: pointer;
    text-align: left;
  }

  .ic-mobileLocationTab span,
  .ic-mobileLocationTab small {
    display: block;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-mobileLocationTab span {
    font-size: 0.76rem;
    font-weight: 900;
  }

  .ic-mobileLocationTab small {
    margin-top: 2px;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.67rem;
    font-weight: 800;
  }

  .ic-mobileLocationTab--active {
    border-color: rgba(34, 211, 238, 0.58);
    background: rgba(34, 211, 238, 0.16);
    color: rgba(214, 251, 255, 0.98);
  }

  .ic-mobileCountList {
    flex-direction: column;
    gap: 10px;
  }

  .ic-mobileCountCard {
    border: 1px solid rgba(255, 255, 255, 0.11);
    border-radius: 14px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.03);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);
  }

  .ic-mobileCountHead {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .ic-mobileCountIdentity {
    min-width: 0;
  }

  .ic-mobileCountMetaLine {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(205, 219, 242, 0.62);
    font-size: 0.7rem;
    font-weight: 800;
    line-height: 1.25;
  }

  .ic-mobileCountMetaLine > span:last-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-mobileCountTitle {
    margin: 5px 0 0;
    color: rgba(244, 248, 255, 0.98);
    font-size: 0.98rem;
    font-weight: 900;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }

  .ic-mobileLineRemoveBtn {
    flex: 0 0 auto;
    width: 26px;
    height: 26px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(248, 113, 113, 0.42);
    border-radius: 999px;
    padding: 0;
    background: rgba(239, 68, 68, 0.16);
    color: rgba(254, 202, 202, 0.96);
    cursor: pointer;
    font-size: 0.74rem;
    font-weight: 900;
    line-height: 1;
  }

  .ic-mobileCountControlRow {
    display: grid;
    grid-template-columns: minmax(86px, 0.55fr) minmax(128px, 1fr);
    gap: 10px;
    align-items: end;
    margin-top: 12px;
  }

  .ic-mobileCountUnit,
  .ic-mobileCountCapture {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 5px;
  }

  .ic-mobileCountInput {
    height: 52px;
    min-height: 52px;
    padding: 10px 12px;
    font-size: 1.16rem;
    font-weight: 900;
  }

  .ic-mobileCountStats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin-top: 10px;
  }

  .ic-mobileCountStat {
    min-width: 0;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 8px 9px;
    background: rgba(255, 255, 255, 0.024);
  }

  .ic-mobileCountStat strong {
    display: block;
    margin-top: 3px;
    color: rgba(238, 244, 255, 0.95);
    font-size: 0.92rem;
    font-weight: 900;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-mobileCountStat small {
    display: block;
    margin-top: 3px;
    color: rgba(196, 211, 235, 0.58);
    font-size: 0.66rem;
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ic-mobileCountStat--global {
    background: rgba(34, 211, 238, 0.045);
  }

  .ic-infoGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
  }

  @media (max-width: 920px) {
    .ic-cardHead,
    .ic-toolbar,
    .ic-modalHeader,
    .ic-modalFooter {
      flex-direction: column;
      align-items: stretch;
    }

    .ic-modalHeaderActions,
    .ic-sessionActions {
      justify-content: flex-start;
    }

    .ic-selectionGrid {
      grid-template-columns: 1fr;
    }

    .ic-sessionUtilityRow {
      grid-template-columns: 1fr;
    }

    .ic-toolbarMain {
      width: 100%;
    }

    .ic-search {
      width: 100%;
    }

    .ic-actions,
    .ic-modalFooterRight {
      justify-content: flex-start;
    }
  }

  @media (max-width: 760px) {
    .ic-modalOverlay--inventorySession {
      padding: 0;
    }

    .ic-modal--inventorySession {
      width: 100vw;
      max-width: 100vw;
      max-height: 100dvh;
      border-radius: 0;
    }

    .ic-modal--inventorySession .ic-modalBody {
      gap: 10px;
      padding: 10px;
    }

    .ic-modal--inventorySession .ic-modalHeader {
      gap: 8px;
    }

    .ic-modal--inventorySession .ic-modalKicker {
      margin-bottom: 5px;
      font-size: 0.66rem;
    }

    .ic-modal--inventorySession .ic-modalTitle {
      font-size: 1.08rem;
      letter-spacing: 0;
    }

    .ic-modal--inventorySession .ic-modalSubtitle,
    .ic-modal--inventorySession .ic-selectionGrid,
    .ic-modal--inventorySession .ic-tableWrap--sessionModal {
      display: none;
    }

    .ic-modal--inventorySession .ic-summaryBar {
      display: none;
    }

    .ic-mobileCountContext {
      display: block;
    }

    .ic-sessionUtilityRow {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 0;
    }

    .ic-notesField {
      display: none;
    }

    .ic-countSearchField {
      order: -1;
      width: calc(100% + 20px);
      margin-left: -10px;
      margin-right: -10px;
      z-index: 30;
    }

    .ic-countSearchField .ic-label {
      padding: 0 10px;
    }

    .ic-countSearchField .ic-input {
      width: 100%;
      border-right: 0;
      border-left: 0;
      border-radius: 0;
      padding-right: 42px;
    }

    .ic-countSearchClear {
      position: absolute;
      top: 50%;
      right: 9px;
      width: 26px;
      height: 26px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(255, 255, 255, 0.16);
      border-radius: 999px;
      padding: 0;
      background: rgba(255, 255, 255, 0.08);
      color: rgba(226, 234, 247, 0.78);
      cursor: pointer;
      font-size: 0.72rem;
      font-weight: 900;
      line-height: 1;
      transform: translateY(-50%);
    }

    .ic-mobileCountList {
      display: flex;
    }

    .ic-sessionAction--export {
      display: none;
    }

    .ic-sessionActions {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 6px;
    }

    .ic-sessionActions .ic-btn {
      width: 100%;
      min-height: 32px;
      border-radius: 9px;
      padding: 6px 7px;
      font-size: 0.7rem;
    }
  }

  @media (max-width: 640px) {
    .ic-card {
      border-radius: 18px;
    }

    .ic-cardHead,
    .ic-toolbar,
    .ic-stats,
    .ic-modalBody {
      padding-left: 14px;
      padding-right: 14px;
    }

    .ic-stats,
    .ic-summaryBar {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .ic-stat,
    .ic-summaryItem,
    .ic-filterCard,
    .ic-infoCard {
      padding: 8px 10px;
      border-radius: 12px;
    }

    .ic-mobileRows {
      gap: 6px 8px;
    }

    .ic-modal {
      width: 100%;
      max-height: calc(100dvh - 20px);
      border-radius: 22px;
    }

    .ic-correctionSummary,
    .ic-correctionLocationRow {
      grid-template-columns: 1fr;
    }

    .ic-modal--inventorySession {
      width: 100vw;
      max-width: 100vw;
      max-height: 100dvh;
      border-radius: 0;
    }
  }
`;

export function normalizeInventoryCountStatus(value) {
  return String(value || "").trim().toLowerCase();
}

export function getInventoryCountStatusMeta(value) {
  const status = normalizeInventoryCountStatus(value);

  if (status === "open") return { label: "Open", tone: "open", key: "open" };
  if (status === "in_progress" || status === "in progress") {
    return { label: "In Progress", tone: "progress", key: "in_progress" };
  }
  if (status === "finalized") {
    return { label: "Finalized", tone: "finalized", key: "finalized" };
  }
  if (status === "reverted") {
    return { label: "Reverted", tone: "reverted", key: "reverted" };
  }
  if (status === "cancelled") {
    return { label: "Cancelled", tone: "cancelled", key: "cancelled" };
  }

  return {
    label: status ? status.replace(/_/g, " ") : "Unknown",
    tone: "draft",
    key: status || "unknown",
  };
}

export function formatInventoryCountDate(value) {
  if (!value) return "-";
  try {
    return new Intl.DateTimeFormat("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(value));
  } catch (error) {
    return "-";
  }
}

export function formatInventoryCountNumber(value) {
  const formatted = NUMBER_FORMATTER.format(value || 0);
  return formatted === "-0" ? "0" : formatted;
}

export function formatInventoryCountInput(value) {
  if (value == null || value === "") return value;
  // PostgreSQL returns exact decimal strings. Strip only the fractional padding.
  if (typeof value === "string" && !/[eE]/.test(value)) {
    const [whole, fraction = ""] = value.split(".");
    const decimals = fraction.replace(/0+$/, "");
    return decimals ? `${whole}.${decimals}` : whole;
  }
  const number = Number(value);
  return Number.isFinite(number) ? INPUT_NUMBER_FORMATTER.format(number) : "";
}

export function formatInventoryCountCurrency(value) {
  return CURRENCY_FORMATTER.format(Number(value || 0));
}

export function truncateInventoryCountText(value, maxLength = 90) {
  const text = String(value || "-");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

export function buildInventoryCountHierarchy(item) {
  return [
    item?.category?.subfamily?.family?.name,
    item?.category?.subfamily?.name,
    item?.category?.name,
    item?.subcategory?.name,
  ]
    .filter(Boolean)
    .join(" / ");
}
